import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCatalog, editCatalog, fetchProducts, clearCatalogsErrors, fetchCategories } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import SortProducts from '../components/catalogs/SortProducts';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  catalog: PropTypes.object,
  products: PropTypes.array,
  catalogId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
  categories: PropTypes.object,
};

class CatalogSortPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchProducts({ limit: 1000 }));
    this.props.dispatch(fetchCatalog(this.props.catalogId));
    this.props.dispatch(fetchCategories());
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.catalog && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Catalog Product Sort edited succesfully!',
        error: false,
      });
    }
  }
  saveSortProducts(data) {
    this.setState({
      edited: true,
    });
    const pCatalog = data;
    delete pCatalog.items;
    this.props.dispatch(editCatalog(pCatalog));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearCatalogsErrors());
    browserHistory.push(`/catalogs/${this.props.catalog.id}?page=1`);
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="catalogs component" style={authPage}>
        <h2>Sort Catalog Products</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <SortProducts
          catalog={this.props.catalog}
          categories={this.props.categories}
          onSave={data => this.saveSortProducts(data)}
        />
      </div>
    );
  }
}

CatalogSortPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CatalogSortPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    catalog: state.catalogs.catalog,
    products: state.products.results,
    catalogId: ownProps.params.id,
    query: ownProps.location.query,
    categories: state.categories,
  };
}

export default withRouter(connect(mapStateToProps)(CatalogSortPage));



// WEBPACK FOOTER //
// ./src/containers/CatalogSortPage.js